import { render, staticRenderFns } from "./MealDetailView.vue?vue&type=template&id=d8835b00&"
import script from "./MealDetailView.vue?vue&type=script&lang=js&"
export * from "./MealDetailView.vue?vue&type=script&lang=js&"
import style0 from "./MealDetailView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports